__turbopack_context__.v({
  "container": "HeroTypography-module__0TgCGG__container",
  "deck": "HeroTypography-module__0TgCGG__deck",
  "headline": "HeroTypography-module__0TgCGG__headline",
  "highlight": "HeroTypography-module__0TgCGG__highlight",
  "isRtl": "HeroTypography-module__0TgCGG__isRtl",
  "visible": "HeroTypography-module__0TgCGG__visible",
});
